<template>
  <div :class="$style.root">
    <div :class="$style.track" />
  </div>
</template>

<style lang="scss" module>
.root {
  height: 4px;
  border-radius: 2px;
  background-color: #19191b;
  overflow: hidden;
}

.track {
  height: 100%;
  width: 33.3333%;
  border-radius: 2px;
  background-color: #4a8dff;
  animation: track-move 1.5s ease-in-out infinite;
}

@keyframes track-move {
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(300%);
  }
}
</style>
